import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	totalInAllGroups: {
		id: 'software.main.board-container.board.column.header.total-in-all-groups',
		defaultMessage: 'Total in all groups',
		description:
			'Message in the tooltip for the total work items count in all groups when hovering over the column header',
	},
});
